import { Icon, IconProps } from '@chakra-ui/react'

export function SocketIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <path 
        fill="currentColor"
        d="M13.3,18.8h-5.3c-.3,0-.5.2-.5.5v2.7c0,.3.2.5.5.5h5.3c.3,0,.5-.2.5-.5v-2.7c0-.3-.2-.5-.5-.5ZM12.8,21.5h-4.3v-1.7h4.3v1.7Z"
      />
      <path 
        fill="currentColor"
        d="M24,18.8h-5.3c-.3,0-.5.2-.5.5v2.7c0,.3.2.5.5.5h5.3c.3,0,.5-.2.5-.5v-2.7c0-.3-.2-.5-.5-.5ZM23.5,21.5h-4.3v-1.7h4.3v1.7Z"
      />
      <path 
        fill="currentColor"
        d="M29.8,4.5c0-.4,0-.7-.2-1-.2-.5-.6-.9-1.1-1.1-.3-.2-.6-.2-1-.2-.4,0-.8,0-1.4,0H5.9c-.6,0-1,0-1.4,0-.4,0-.7,0-1,.2-.5.2-.9.6-1.1,1.1-.2.3-.2.6-.2,1,0,.4,0,.8,0,1.4v20.3c0,.6,0,1,0,1.4,0,.4,0,.7.2,1,.2.5.6.9,1.1,1.1.3.2.6.2,1,.2.4,0,.8,0,1.4,0h20.3c.6,0,1,0,1.4,0,.4,0,.7,0,1-.2.5-.2.9-.6,1.1-1.1.2-.3.2-.6.2-1,0-.4,0-.8,0-1.4V5.9c0-.6,0-1,0-1.4ZM28.8,26.1c0,.6,0,1,0,1.3,0,.3,0,.5-.1.6-.1.3-.4.5-.7.7-.1,0-.3.1-.6.1-.3,0-.7,0-1.3,0H5.9c-.6,0-1,0-1.3,0-.3,0-.5,0-.6-.1-.3-.1-.5-.4-.7-.7,0-.1-.1-.3-.1-.6,0-.3,0-.7,0-1.3V5.9c0-.6,0-1,0-1.3,0-.3,0-.5.1-.6.1-.3.4-.5.7-.7.1,0,.3-.1.6-.1.3,0,.7,0,1.3,0h20.3c.6,0,1,0,1.3,0,.3,0,.5,0,.6.1.3.1.5.4.7.7,0,.1.1.3.1.6,0,.3,0,.7,0,1.3v20.3Z"
      />
      <path 
        fill="currentColor"
        d="M17.3,8.2h-2.7c-.3,0-.5.2-.5.5v4.7c0,.3.2.5.5.5h2.7c.3,0,.5-.2.5-.5v-4.7c0-.3-.2-.5-.5-.5ZM16.8,12.8h-1.7v-3.7h1.7v3.7Z"
      />
    </Icon>
  )
}
